import { DateTime } from 'luxon';

import { Period, ALL_PERIODS, DateQuery } from '../types';

const isValidPeriod = (value: string): value is Period => ALL_PERIODS.includes(value as Period);

const startDateGreaterThanEndDate = (start: Date, end: Date) => {
  const startDateTime = DateTime.fromJSDate(start).startOf('day');
  const endDateTime = DateTime.fromJSDate(end).startOf('day');
  return startDateTime > endDateTime;
};

const dateLessThanThreeMonthsAgo = (from: Date) => {
  const fromDateTime = DateTime.fromJSDate(from).startOf('day');
  const threeMonthsAgo = DateTime.now().startOf('day').minus({ months: 3 }).plus({ days: 1 });
  return fromDateTime < threeMonthsAgo;
};

const dateGreaterThanToday = (end: Date) => {
  const toDateTime = DateTime.fromJSDate(end).startOf('day');
  const startOfToday = DateTime.now().startOf('day');
  return toDateTime > startOfToday;
};

export const isValidRangeQuery = (query: {
  period: string | null | undefined;
  from: DateQuery;
  to: DateQuery;
}): query is { period: Period; from: Date; to: Date } => {
  const { period, from, to } = query;

  if (!period || !isValidPeriod(period)) {
    return false;
  }

  if (period === 'custom') {
    if (!from || !to) {
      return false;
    }

    if (startDateGreaterThanEndDate(from, to) || dateLessThanThreeMonthsAgo(from) || dateGreaterThanToday(to)) {
      return false;
    }
  }

  if (period !== 'custom' && (from || to)) {
    return false;
  }

  return true;
};
